import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import UserForm from '../../components/Users/UserForm';
import Dashboard from '../../components/Dashboard';
import { 
  getUserDetail, 
  updateUser, 
  deleteUserImage,
  getUserTypes
} from '../../redux/modules/user/action';

class EditUser extends React.Component {
  async componentDidMount () {
    const { dispatch, match } = this.props;
    await dispatch(getUserDetail(match.params.userId));
    await dispatch(getUserTypes());
  }

  editUser = (formData) => {
    const { dispatch, match } = this.props;
    dispatch(updateUser(match.params.userId, formData));
  }

  deleteImage = () => {
    const { dispatch, match } = this.props;
    dispatch(deleteUserImage(match.params.userId));
  }

  render () {
    const { 
      handleSubmit, 
      isVerified, 
      isActive, 
      message, 
      profileImage,
      userTypes
    } = this.props;
    return (
      <Dashboard>
        <UserForm 
          handleSubmit={handleSubmit}
          editUser={this.editUser}
          isVerified={isVerified}
          isActive={isActive}
          message={message}
          profileImage={profileImage}
          deleteImage={this.deleteImage}
          userTypes={userTypes}
        />
      </Dashboard>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    initialValues: state.user.details,
    isVerified: state.user.details && state.user.details.isVerified,
    isActive: state.user.details && state.user.details.isActive,
    profileImage: state.user.details && state.user.details.image,
    message: state.user.message,
    userTypes: state.user.userTypes
  }
}

EditUser.propTypes = {
  initialValues: PropTypes.object,
  isVerified: PropTypes.bool,
  isActive: PropTypes.bool,
}

EditUser.defaultProps = {
  isVerified: false,
  isActive: false
}

export default connect(mapStateToProps)(reduxForm({ 
  form: "editUser",
  enableReinitialize: true
})(EditUser));
